import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { store } from '..'
import { userApi } from '../services'

const fetchCurrentUser = createAsyncThunk(
  'user/current',
  async (_, { rejectWithValue }) => {
    try {
      const { user = {} } = await store.dispatch(
        userApi.endpoints.getCurrentUser.initiate()
      ).unwrap()

      return user
    } catch (error) {
      throw rejectWithValue(error)
    }
  }
)

const initialState = {
  current: {}
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCurrentUser.fulfilled, (state, action) => {
      state.current = action?.payload
    })

    builder.addCase(fetchCurrentUser.rejected, (state, _action) => {
      state.current = {}
    })
  }
})

export {
  fetchCurrentUser
}
export default userSlice.reducer
